import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { MODULE_PERMISSIONS } from '../../../Components/constants/permissions';
const API_BASE_URL = process.env.REACT_APP_API_URL;
function AddEditRolePage() {
  const { id } = useParams();
  const [roleName, setRoleName] = useState('');
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const navigate = useNavigate();

  // Fetch role data if editing
  const fetchRole = useCallback(async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/roles/${id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      const role = res.data;
      setRoleName(role.name);
      setSelectedPermissions(role.permissions || []);
    } catch (err) {
      console.error('Failed to load role:', err);
      alert('Failed to load role data');
      navigate('/role');
    }
  }, [id, navigate]);

  useEffect(() => {
    if (id) {
      fetchRole();
    }
  }, [id, fetchRole]);

  const handleCheckboxChange = (perm) => {
    setSelectedPermissions((prev) =>
      prev.includes(perm) ? prev.filter((p) => p !== perm) : [...prev, perm]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');

    if (!token || !userId) {
      alert('User not logged in');
      return;
    }

    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };

      if (id) {
        await axios.put(
          `${API_BASE_URL}/api/roles/${id}`,
          {
            name: roleName,
            permissions: selectedPermissions,
            updatedBy: userId,
          },
          config
        );
        alert('Role updated successfully');
      } else {
        await axios.post(
          `${API_BASE_URL}/api/roles`,
          {
            name: roleName,
            permissions: selectedPermissions,
            createdBy: userId,
          },
          config
        );
        alert('Role created successfully');
      }

      navigate('/role');
    } catch (error) {
      console.error(id ? 'Error updating role:' : 'Error creating role:', error);
      alert(id ? 'Failed to update role' : 'Failed to create role');
    }
  };

  return (
    <div className="container-fluid p-4">
      <div
        className="text-white p-3 mb-3 rounded-top d-flex justify-content-between align-items-center"
        style={{ backgroundColor: '#102234' }}
      >
        <h5 className="mb-0">{id ? 'Edit Role & Access' : 'Create Role & Access'}</h5>
        <button className="btn btn-light btn-sm" onClick={() => navigate('/role')}>
          &larr; Back to Role & Access Management
        </button>
      </div>

      <div
        className="bg-white p-4 border rounded-bottom shadow-sm"
        style={{ borderColor: '#102234' }}
      >
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <h6
              className="fw-bold border-bottom pb-2"
              style={{ color: '#102234', borderColor: '#102234' }}
            >
              General Details
            </h6>
            <label className="form-label fw-semibold mt-2">Role Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Role Name"
              required
              value={roleName}
              onChange={(e) => setRoleName(e.target.value)}
              style={{ borderColor: '#102234' }}
            />
          </div>

          <div className="mb-4">
            <h6
              className="fw-bold border-bottom pb-2"
              style={{ color: '#102234', borderColor: '#102234' }}
            >
              Permissions
            </h6>
            <div className="row">
              {Object.entries(MODULE_PERMISSIONS).map(([module, actions]) => (
                <div className="col-md-4 mb-3" key={module}>
                  <h6 style={{ color: '#102234' }}>{module}</h6>
                  {actions.map((action) => {
                    const perm = `${action}_${module}`;
                    return (
                      <div className="form-check" key={perm}>
                        <input
                          style={{
                            border: '1px solid black',
                            width: '20px',
                            height: "20px"

                          }}
                          className="form-check-input"
                          type="checkbox"
                          id={perm}
                          checked={selectedPermissions.includes(perm)}
                          onChange={() => handleCheckboxChange(perm)}
                        />
                        <label className="form-check-label text-capitalize" htmlFor={perm}>
                          {action.replace(/_/g, ' ')}
                        </label>
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>

          <div className="d-flex justify-content-end gap-2">
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={() => navigate('/role')}
            >
              Cancel
            </button>
            <button
              className="btn"
              type="submit"
              style={{ backgroundColor: '#102234', color: '#fff' }}
            >
              {id ? 'Update' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddEditRolePage;
